import { useCallback, useEffect, useState } from "react";
import { API_BASE, fetchWithAuth } from "../utils/api";

const normalizeRole = (role) => {
  if (!role) return role;
  const roleLower = String(role).toLowerCase();
  if (roleLower === "dispatchers") return "Dispatchers";
  if (roleLower === "accounting") return "accounting";
  return role;
};

export function useAuth() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const loadUser = useCallback(async () => {
    try {
      const res = await fetchWithAuth(`${API_BASE}/auth/check-login`);
      if (!res.ok) {
        setUser(null);
        return;
      }
      const data = await res.json();

      const userRole = data?.user?.role?.toLowerCase();
      const allowedRoles = ["dispatchers", "accounting", "admin", "driver"];
      if (!allowedRoles.includes(userRole)) {
        setUser(null);
        return;
      }

      setUser({
        ...data.user,
        role: normalizeRole(data.user.role),
      });
    } catch (err) {
      console.error("Lỗi khi lấy thông tin user:", err);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    const run = async () => {
      try {
        await loadUser();
      } finally {
        setAuthLoading(false);
      }
    };
    run();
  }, [loadUser]);

  const logout = useCallback(async () => {
    try {
      await fetchWithAuth(`${API_BASE}/auth/logout`, { method: "POST" });
    } catch (err) {
      console.error("Lỗi khi đăng xuất:", err);
    } finally {
      setUser(null);
    }
  }, []);

  return { user, setUser, authLoading, reloadUser: loadUser, logout };
}

